(() => {
  const root = document.getElementById('MainContent');
  if (!root) return;
  const selector = '.jdgm-review-widget';
  const config = document.getElementById('CistaReviewSummaryConfig');
  if (!config) return;
  let labels;
  try { labels = JSON.parse(config.textContent); } catch (_) { return; }
  if (![labels.rating, labels.countOne, labels.countOther].every(label => typeof label === 'string')) return;
  const locale = document.documentElement.lang || 'en';
  const number = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 });
  const widgets = new Map();
  const pending = new Set();
  let frame = 0;

  const formatSummary = widget => {
    widget.querySelectorAll('.jm-average-rating-display').forEach(summary => {
      const text = Array.from(summary.querySelectorAll('.jm-text')).filter(element => !element.querySelector('.jm-text'));
      const rating = text.find(element => {
        const match = element.textContent.trim().match(/^\D*(\d(?:[.,]\d+)?)(?:\D+5)?\D*$/u);
        return match && Number(match[1].replace(',', '.')) <= 5;
      });
      if (!rating) return;
      const count = text.find(element => element !== rating && element.parentElement === rating.parentElement &&
        /^\D*\d[\d.,\s\u00a0\u202f]*\D*$/u.test(element.textContent.trim()));
      if (!count) return;
      const ratingValue = Number(rating.textContent.match(/\d(?:[.,]\d+)?/u)[0].replace(',', '.'));
      const countValue = Number(count.textContent.replace(/\D/g, ''));
      if (!Number.isSafeInteger(countValue)) return;
      const ratingText = labels.rating.replace('[rating]', number.format(ratingValue)).replace('[max]', number.format(5));
      const countText = (countValue === 1 ? labels.countOne : labels.countOther).replace('[count]', number.format(countValue));
      if (rating.textContent !== ratingText) rating.textContent = ratingText;
      if (count.textContent !== countText) count.textContent = countText;
      rating.classList.add('cista-review-summary__rating');
      count.classList.add('cista-review-summary__count');
      rating.parentElement.classList.add('cista-review-summary__lines');
    });
  };

  const schedule = widget => {
    pending.add(widget);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      pending.forEach(item => { if (item.isConnected) formatSummary(item); });
      pending.clear();
    });
  };

  const connect = widget => {
    if (widgets.has(widget)) return;
    const observer = new MutationObserver(records => {
      if (records.length) schedule(widget);
    });
    observer.observe(widget, { childList: true, characterData: true, subtree: true });
    widgets.set(widget, observer);
    formatSummary(widget);
  };

  root.querySelectorAll(selector).forEach(connect);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches(selector)) connect(node);
      node.querySelectorAll(selector).forEach(connect);
    }));
    widgets.forEach((observer, widget) => {
      if (!widget.isConnected) { observer.disconnect(); widgets.delete(widget); pending.delete(widget); }
    });
  }).observe(root, { childList: true, subtree: true });
})();
